import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPayClassificationsSlice, {
  PayClassificationsSlice,
} from './pay-classifications/slice'
import createManageSlice, {
  ManageSlice,
} from './pay-classifications/manage/slice'
import createAddPayClassificationSlice, {
  AddPayClassificationSlice,
} from './pay-classifications/add/slice'
import createEditPayClassificationSlice, {
  EditPayClassificationSlice,
} from './pay-classifications/edit/slice'
import createLeaveTypesSlice, { LeaveTypesSlice } from './leave-types/slice'
import createEditLeaveTypeSlice, {
  EditLeaveTypeSlice,
} from './leave-types/edit/slice'
import createAddLeaveTypeSlice, {
  AddLeaveTypeSlice,
} from './leave-types/add/slice'
import createPayAdjustmentPackagesSlice, {
  PayAdjustmentPackagesSlice,
} from './pay-rules/slice'
import createComplianceSharedSlice, { ComplianceSharedSlice } from './slice'

const useComplianceStore = create<
  PayClassificationsSlice &
    ManageSlice &
    AddPayClassificationSlice &
    EditPayClassificationSlice &
    LeaveTypesSlice &
    EditLeaveTypeSlice &
    AddLeaveTypeSlice &
    PayAdjustmentPackagesSlice &
    SharedSlice &
    ComplianceSharedSlice
>()((...props) => ({
  ...createPayClassificationsSlice(...props),
  ...createManageSlice(...props),
  ...createAddPayClassificationSlice(...props),
  ...createEditPayClassificationSlice(...props),
  ...createLeaveTypesSlice(...props),
  ...createEditLeaveTypeSlice(...props),
  ...createAddLeaveTypeSlice(...props),
  ...createPayAdjustmentPackagesSlice(...props),
  ...createSharedSlice(...props),
  ...createComplianceSharedSlice(...props),
}))

export default useComplianceStore
